const General = require("./src/general");
module.exports = General;

if (require.main === module) {
  const gs = new General();
  console.log(gs.dtKStrToJson("1234567890123456789012345678901234567890"));
}
